import React from 'react';
import { Create, useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Form from './detail/Form';
import Aside from './detail/Aside';

const useStyles = makeStyles({
  left: {
    width: 'calc(100% - 350px)',
  },
});

const CleanerContractCreate = (props) => {
  const classes = useStyles();
  const translate = useTranslate();
  useDocumentTitle(
    translate('app.page_title.create', {
      resource: translate('resources.cleaner_contract.name', {
        smart_count: 1,
      }),
    }),
  );

  return (
    <Create {...props} className={classes.left}>
      <Form aside={<Aside {...props} />} />
    </Create>
  );
};

export default CleanerContractCreate;
